import $axios from "../../api/axios";

function getAllBlogPostsApi({ params, callback }) {
    $axios
        .get(`/oa/blog/blogs/published/${params.page}/${params.pageSize}`)
        .then(res => {
            callback(res);
        })
        .catch(err => {
            console.log(err);
        });
}

function getBlogPostApi({ params, callback }) {
    console.log(params);
    $axios
        .get(`/oa/blog/blog/${params.blogId}`)
        .then(res => {
            callback(res);
        })
        .catch(err => {
            console.log(err);
        });
}
export default {
    getAllBlogPostsApi,
    getBlogPostApi
};



// WEBPACK FOOTER //
// ./src/api/blog/blogApi.js